import { Observable } from 'rxjs';
import { Inject, Injectable } from '../../injection';
import { InvitationsLinksList } from '../data/invitations-links-list.do';
import { Invite } from '../data/invite.do';
import { RegisterViewModel } from '../data/register-view-model.do';
import { ApiEndpointConfiguration } from '../interfaces/api-endpoint-configuration.interface';
import { IMobizHttpService } from '../interfaces/mobiz-http.interface';
import { MobizServerApi } from '../other/mobiz-server-api.enum';
import { IInviteService } from './invite.interface';

@Injectable()
export class InviteService implements IInviteService {
  constructor(
    @Inject(IMobizHttpService) private http: IMobizHttpService,
  ) {
  }

  /**
   * @inheritdoc
   */
  getRegistration(inviteId: string): Observable<RegisterViewModel> {
    let config: ApiEndpointConfiguration = {
      // Note: On backend, the invitation controller does not respect the REST conventions,
      // we are getting a RegisterViewModel instead of invitation.
      serverApi: MobizServerApi.Invite,
      urlParameters: {
        id: inviteId
      }
    };

    return this.http.get(new RegisterViewModel(), config);
  }

  /**
   * @inheritdoc
   */
  resend(id: any): Observable<Object> {
    let config: ApiEndpointConfiguration = {
      serverApi: MobizServerApi.InviteResend,
      urlParameters: {
        id: id
      }
    };

    return this.http.post(new Invite(), config);
  }

  /**
   * @inheritdoc
   */
  cancel(id: any): Observable<Object> {
    let config: ApiEndpointConfiguration = {
      serverApi: MobizServerApi.Invite,
      urlParameters: {
        id: id
      }
    };

    return this.http.delete(new Invite(), config);
  }

  /**
   * @inheritdoc
   */
  createInvites(organizationId: string, invites: Invite[]): Observable<InvitationsLinksList> {
    let config: ApiEndpointConfiguration = {
      serverApi: MobizServerApi.Invite,
      body: JSON.stringify(invites),
      urlParameters: {
        id: organizationId,
      }
    };

    return this.http.post(new InvitationsLinksList(), config);
  }
}
